import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Sort",
  "use": "Sort-usage",
  "viewBox": "0 0 14 20",
  "content": "<symbol viewBox=\"0 0 14 20\" id=\"Sort\"><path d=\"M5 7.01V0H3v7.01H0L4 11l4-3.99H5zm1 5.98h3V20h2v-7.01h3L10 9l-4 3.99z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol